import type {
  CoreApiResponseListV2,
  CoreItemCategoryPayload,
  CoreItemCategory,
  ParameterID,
} from '@flecto/types'

import { api } from '../../../services/api'

/**
 * Update a item category by ID.
 *
 * @endpoint PATCH /api/me/item_categories/{internal_id}
 * @scope saas
 * @see https://flecto.dev/api-4724138
 */
export async function updateItemCategory(
  categoryId: ParameterID,
  category: CoreItemCategoryPayload
): Promise<CoreItemCategory> {
  const body: CoreApiResponseListV2<'item_category', CoreItemCategoryPayload> =
    {
      item_category: { ...category },
    }

  const { data } = await api.patch(
    `/api/me/item_categories/${categoryId}`,
    body
  )

  return data?.item_category || {}
}
